(() => {
  const config = document.getElementById('toni-fi-campaign-visibility');
  if (!config) return;
  const html = document.documentElement;
  const market = (config.dataset.marketCountry || '').toUpperCase();
  let controller;

  async function resolveVisibility() {
    controller?.abort();
    html.dataset.toniFiCampaign = 'hidden';
    if (market !== 'FI' || !document.querySelector('main [data-toni-fi-campaign]')) return;

    const request = new AbortController();
    controller = request;
    const timeout = setTimeout(() => request.abort(), 5000);
    try {
      const root = (config.dataset.contextRoot || '/').replace(/\/?$/, '/');
      const url = new URL(root + 'browsing_context_suggestions.json', window.location.origin);
      url.searchParams.set('country[enabled]', 'true');
      url.searchParams.set('language[enabled]', 'false');
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: request.signal
      });
      if (!response.ok) return;
      const context = await response.json();
      const detected = context?.detected_values?.country?.handle;
      if (!request.signal.aborted && detected?.toUpperCase() === 'FI') {
        html.dataset.toniFiCampaign = 'visible';
      }
    } catch {
      // Keep the promotion hidden if detection fails. The regular store remains usable.
    } finally {
      clearTimeout(timeout);
    }
  }

  resolveVisibility();
  document.addEventListener('shopify:section:load', resolveVisibility);
  window.addEventListener('pagehide', () => {
    controller?.abort();
    html.dataset.toniFiCampaign = 'hidden';
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) resolveVisibility();
  });
})();
